import type { PortableTextComponentProps } from '@portabletext/react';
import { stegaClean } from '@sanity/client/stega';
import type { ImageWithMetadata} from '../components/SanityImage';
import { CaptionedSanityImage, imageWithMetadataGroq } from '../components/SanityImage';
import type { FileComponentProps } from './fileComponent';
import FileComponent, { fileComponentGroq } from './fileComponent';

export type FloatProps = {
    side: 'left' | 'right';
    _key: string;
} & (
    | {
          type: 'imageWithMetadata';
          imageWithMetadata: ImageWithMetadata;
      }
    | {
          type: 'fileComponent';
          fileComponent: FileComponentProps;
      }
);

export const floatGroq = /* groq */ `{
  type,
  'leftOrRight': side,
  type == 'imageWithMetadata' => { imageWithMetadata ${imageWithMetadataGroq} },
  type == 'fileComponent' => { fileComponent -> ${fileComponentGroq} }
}`;

export function Float({ value: { side, _key, ...props } }: PortableTextComponentProps<FloatProps>) {
    switch (props.type) {
        case 'imageWithMetadata':
            return (
                <CaptionedSanityImage
                    studioPath={[{ _key }]}
                    image={props.imageWithMetadata}
                    float={stegaClean(side)}
                    lazy
                    sizes="277px"
                    widths={[277, 277 * 2, 277 * 3]}
                />
            );
        case 'fileComponent':
            return <FileComponent value={props.fileComponent} float={stegaClean(side)} />;
        default:
            return null;
    }
}
